import React from 'react';
import ReactPlayer from 'react-player'
import { makeStyles } from '@material-ui/core/styles';
import { Container, Typography, Box, List, Button } from '@material-ui/core';
import CommentModal from './CommentModal'
import CommentItem from './CommentItem'


const useStyles = makeStyles((theme) => ({
  root: {
    // width: '100%',
  },
  container: {
    width: 'calc(100% - 280px)',
    maxWidth: '804px',
    marginLeft: '256px',
    minHeight: 'calc(100vh - 64px)',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),
    
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 'auto',
    },
  },

  pageTitle: {
    marginBottom: theme.spacing(2),
    color: 'rgba(51, 51, 51, 0.87)',
  },
  
  descriptionTitle: {
    marginBottom: theme.spacing(2),
    color: '#666666',
  },

  descriptionText: {
    color: 'rgba(102, 102, 102, 0.87)',

    '& > * + *': {
      marginTop: theme.spacing(3),
    },
    
    '& > ul': {
      marginLeft: theme.spacing(2),
    },
  },
  
  videoContainer: {
    marginBottom: theme.spacing(3),
  },
  
  descriptionContainer: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(3),
    background: '#FAFAFA',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12)',
    borderRadius: '2px',
  },
  
  commentItem: {
    marginBottom: -theme.spacing(3),
  },
  
  footerBox: {
    paddingTop: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
  },
  
  buttonGreen: {
    background: '#90C71A',
    color: '#fff',
  },
}));


function VideoInfo(props) {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const {title, subtitle, description} = props.info

  return (
    <Container className={classes.container} maxWidth="md">
      <Typography gutterBottom variant="h5" className={classes.pageTitle} component="h1">{title}</Typography>
      <Box className={classes.videoContainer}>
        <ReactPlayer 
          url={props.videoLink}
          controls
          width='100%'
          config={{
            file: {
              attributes: {controlsList:"nodownload"}
            }
          }}
        />
      </Box>
      <Box className={classes.descriptionContainer}>
        {subtitle ? <Typography Typography gutterBottom variant="h6"  component="h2">{subtitle}</Typography> : ''}
        <Typography gutterBottom variant="body2" component="div" className={classes.descriptionText} dangerouslySetInnerHTML={{ __html:description}}></Typography>
      </Box>
      <Typography gutterBottom variant="h5" className={classes.pageTitle} component="h3">Комментарии</Typography>
      <Box className={classes.descriptionContainer}>
        {(props.comments && props.comments.length > 0) ?
          <List className={classes.commentItem}>
            {(props.comments && props.comments.length > 0) ? props.comments.map((item, index) => (
              <CommentItem key={index} info={item} />
            )): ''}
          </List>
        : ''}
        <Box className={(props.comments && props.comments.length > 0) ? classes.footerBox : ''}>
          <Button className={classes.buttonGreen} variant="contained" onClick={handleClickOpen}>ДОБАВИТЬ КОММЕНТАРИЙ</Button>
        </Box>
      </Box>
      <CommentModal openModal={open} handleClose = {handleClose} addComment = {props.addComment} />
    </Container>
  );
}

export default VideoInfo;
